import { Component } from '@angular/core';
import { LucideAngularModule, CircleAlert } from 'lucide-angular';

@Component({
    selector: 'app-session-expired-modal',
    standalone: true,
    imports: [LucideAngularModule],
    template: `
        <div class="text-center py-5">
            <lucide-icon
                [img]="CircleAlert"
                [size]="64"
                [strokeWidth]="2"
                class="mx-auto mb-6 text-red-600"
            ></lucide-icon>
            <p class="text-gray-700 text-base leading-relaxed mb-6">
                Your session has expired due to inactivity. Please log in again to continue.
            </p>
            <div class="flex justify-center">
                <button class="button button--primary" (click)="returnToLogin()">Return to Login</button>
            </div>
        </div>
    `,
})
export class SessionExpiredModalComponent {
    readonly CircleAlert = CircleAlert;

    returnToLogin(): void {
        window.location.reload();
    }
}
